module.exports = __webpack_public_path__ + "static/pokoj-nr5-photo07-nikon_thumb-894ae9146a10077da73a3a8e65147dd9.jpg";